/* S1 Feature Split: fade-ins only (static content) — .s1-fs-fade +
   IntersectionObserver, same contract as .s1-ch-fade / .s1-ts-fade. */

class S1FeatureSplit extends HTMLElement {
  connectedCallback() {
    if (!this._fadeIo) {
      this._fadeIo = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting) {
            en.target.classList.add('is-visible');
            this._fadeIo.unobserve(en.target);
          }
        });
      }, { threshold: 0.2 });
    }
    this.querySelectorAll('.s1-fs-fade:not(.is-visible)').forEach((el) => this._fadeIo.observe(el));
  }

  disconnectedCallback() {
    if (this._fadeIo) this._fadeIo.disconnect();
  }
}

if (!customElements.get('s1-feature-split')) {
  customElements.define('s1-feature-split', S1FeatureSplit);
}
